import React from "react";
import Navbar from "./Componets/Navbar";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import QuickView from "./Pages/QuickView";
function App() {
  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Switch>
          {/* Default route serves the entire landing page */}
          <Route path="/" component={QuickView} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
